/**
 * Aniwell video reviews — polaroid wall (sections/aniwell-video-reviews.liquid).
 * - Clips autoplay silently on loop for every visitor. With data-pause-offscreen they
 *   pause while scrolled away and resume on return. With data-respect-motion they
 *   stay paused for visitors who ask their device to reduce motion.
 * - Mobile carousel dots follow the swipe position.
 * - "Read more" expands clamped reviews.
 */
(() => {
  'use strict';

  const $$ = (s, r) => Array.from(r.querySelectorAll(s));
  const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const play = (v) => { const p = v.play(); if (p && p.catch) p.catch(() => {}); };

  function bindClips(root) {
    const clips = $$('[data-aw-vr-clip]', root);
    if (!clips.length) return;
    if (root.dataset.respectMotion === 'true' && prefersReduced) {
      clips.forEach((v) => { v.removeAttribute('autoplay'); v.pause(); });
      return;
    }
    clips.forEach((v) => { v.muted = true; });
    if (root.dataset.pauseOffscreen !== 'true' || !('IntersectionObserver' in window)) {
      clips.forEach(play);
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => (e.isIntersecting ? play(e.target) : e.target.pause()));
    }, { rootMargin: '120px 0px', threshold: 0.15 });
    clips.forEach((v) => io.observe(v));
  }

  function bindDots(root) {
    const row = root.querySelector('[data-aw-vr-row]');
    const dots = $$('[data-aw-vr-dot]', root);
    const cards = $$('[data-aw-vr-card]', root);
    if (!row || !dots.length || cards.length < 2) return;
    const step = () => (cards[1].offsetLeft - cards[0].offsetLeft) || row.clientWidth || 1;
    const sync = () => {
      const i = Math.min(cards.length - 1, Math.round(row.scrollLeft / step()));
      dots.forEach((d, k) => { d.classList.toggle('is-active', k === i); d.setAttribute('aria-current', k === i); });
    };
    row.addEventListener('scroll', sync, { passive: true });
    dots.forEach((d, k) => d.addEventListener('click', () => row.scrollTo({ left: k * step(), behavior: prefersReduced ? 'auto' : 'smooth' })));
    sync();
  }

  function bindReadMore(root) {
    $$('[data-aw-vr-more]', root).forEach((btn) => {
      const body = btn.previousElementSibling;
      if (!body) return;
      requestAnimationFrame(() => { if (body.scrollHeight <= body.clientHeight + 2) btn.hidden = true; });
      btn.addEventListener('click', () => {
        const open = body.classList.toggle('is-clamped') === false;
        btn.textContent = open ? btn.dataset.less : btn.dataset.more;
        btn.setAttribute('aria-expanded', open);
      });
    });
  }

  const init = (scope) => {
    scope.querySelectorAll('[data-aw-vr]').forEach((root) => {
      if (root.dataset.awReady) return;
      root.dataset.awReady = 'true';
      bindClips(root);
      bindDots(root);
      bindReadMore(root);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
